import React from 'react';
import AppBar from "../../../Components/header/index";
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
// import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
// import Divider from '@material-ui/core/Divider';
// import Profile from "../../../images/profile.png"
// import Input from "@material-ui/core/Input";
import { TextInput } from 'react-admin';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';
// import {useRedirect} from "react-admin";
// import {useAttendees} from "./../hooks"

const useStyles = makeStyles(theme => ({
    "@global": {
        body: {
            backgroundColor: "#F7F7F7",
        }
    },
    Avatar: {
        height: "35px"
    }
}));
export default function Schedule({ handleSubmit,
    reset,
    submitting,
    pristine,
    values,
    signUpGoogle,
    signUpGoogleFailure,
    props,
    ...rest }) {
    const classes = useStyles();
    return (
        <div className={classes.div}>
            <AppBar />
            <div style={{ paddingLeft: "4%", paddingRight: "4%", }}>
                <form onSubmit={handleSubmit} noValidate>
                    <Paper style={{ marginTop: "0px", padding: "15px", boxShadow: "none", }}>
                        <Grid container  >
                            <Grid item sm={3} xs={3}></Grid>
                            <Grid item sm={9} xs={9}>
                                <Typography variant="subtitle2" style={{ marginTop: "10px", textAlign: "left", fontSize: "24px" }}>Request Message</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing="1" style={{ marginTop: "10px" }}>
                            <Grid item sm={3} xs={1}></Grid>
                            <Grid item sm={6} xs={11}>
                                {/* <TextareaAutosize
                                    style={{ width: "90%", borderRadius: "10px", paddingLeft: "5%" }}
                                    aria-label="minimum height"
                                    rowsMin={10}
                                    placeholder="Message for Mentor from Mentee"
                                /> */}
                                <TextInput multiline source="message" variant="outlined"  rows="8" style={{width:"100%"}} />
                            </Grid>
                            {/* <Grid item xs={6}></Grid> */}

                        </Grid>

                        <Grid container style={{ marginTop: "15vh" }}>
                            <Grid item xs={6}>
                                <Button
                                    style={{ background: "#D14002", color: "white", borderRadius: "5px", padding: "5px  ", width: "100px" }}
                                    onClick={() => { }}>
                                    Cancel
                    </Button>
                            </Grid>
                            <Grid item xs={6} >
                                <Button type="submit" style={{ background: "#0288D1", color: "white", borderRadius: "5px", float: "right", padding: "5px  ", width: "90px" }}

                                >

                                    Next
                </Button>
                            </Grid>

                        </Grid>
                    </Paper>
                </form>
            </div>
        </div>
    );
}
